<template>
  <div v-if="table.data.length > 0">
    <a-table
      :data-source="table.data"
      bordered
      :pagination="false"
      :columns="columns"
      rowKey="id"
      :scroll="{ y: 'calc( 100vh - 300px)' }"
      :defaultExpandAllRows="true"
    >
      <template #action="{ record }">
        <a-space v-if="record.pid !== 0">
          <a-button
            type="primary"
            size="small"
            @click="handleUpdateDepartment(record)"
            >修改</a-button
          >

          <a-button
            type="danger"
            size="small"
            @click="handleDeleteDepartMent(record)"
          >
            删除
          </a-button>
        </a-space>

        <a-space v-else>
          <a-button @click="handleUpdateDepartment(null)" size="small"
            >新增</a-button
          >
        </a-space>
      </template>
    </a-table>
  </div>

  <department-from
    ref="departmentFormRef"
    @updateTable="updateTable"
  ></department-from>
</template>

<script>
import { defineComponent, inject, provide, ref, watch } from "vue";
import { useTable } from "@/views/notice/serve/table";
import {
  deleteStructure,
  getStructure,
  saveStructure,
} from "@/request/view/personal";
import departmentFrom from "@/views/personnelManagement/component/department/form.vue";

export default defineComponent({
  components: { departmentFrom },
  setup() {
    const {
      requestConfig,
      table,
      requestPayload,
      initPayload,
      getListData,
      searchData,
      deleteRecords,
    } = useTable();

    initPayload({});

    const columns = [
      {
        title: "部门名称",
        dataIndex: "structureName",
        align: "left",
      },
      {
        title: "操作",
        slots: {
          customRender: "action",
        },
        align: "center",
      },
    ];

    requestConfig.pull_fn = getStructure;
    requestConfig.delete_fn = deleteStructure;

    const departmentFormRef = ref();

    provide("structureData", table.data);

    const handleUpdateDepartment = (record) => {
      departmentFormRef.value.showModal({
        type: record === null ? "insert" : "update",
        title: record === null ? "新增部门" : "更新部门",
        data: record,
      });
    };

    const handleDeleteDepartMent = (record) => {
      deleteRecords([record.id], {
        title: `确认删除${record.structureName}?`,
      }).then((res) => {
        getData();
      });
    };

    const handleProjectDetails = (record) => {
      console.log(record);
    };

    const updateTable = () => {
      getData();
    };

    const deleteEmptyChild = (list) => {
      list.forEach((item) => {
        if (item.children && item.children.length === 0) {
          delete item.children;
        }

        if (item.children && item.children.length > 0) {
          deleteEmptyChild(item.children);
        }
      });
    };

    const getData = () => {
      getListData({ unPagingRequest: true }).then((res) => {
        deleteEmptyChild(table.data);
      });
    };

    const tabActivekey = inject("tabActivekey", null);

    watch(
      () => tabActivekey,
      (val) => {
        if (val && val.value === "组织架构") {
          getData();
        }
      },
      {
        immediate: true,
        deep: true,
      }
    );

    return {
      table,
      columns,
      departmentFormRef,
      updateTable,
      handleDeleteDepartMent,
      handleProjectDetails,
      handleUpdateDepartment,
    };
  },
});
</script>

<style lang="less" scoped>
</style>
